const localFileUrl = (path) => `${process.env.REACT_APP_SERVER_APP_BASE_URL}/${path}`

module.exports = { localFileUrl }